import { Component, Input, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { constants } from 'src/app/components/monitor/services/constants';

@Component({
    selector: 'server-validation',
    templateUrl: './server-validation-form.component.html',
    styleUrls: ['./server-validation-form.component.css'],
    standalone: true,
    imports: [TranslateModule]
})
export class ServerServerValidateFormComponent implements OnInit {

  @Input() isValidateField:any;
  @Input() customClass:any;
  newClass:string = "text-danger validation-container";

  constructor() { }

  ngOnInit(): void {
    if (constants.__isNoEmpty(this.customClass)) {
      this.newClass = this.customClass+" validation-container";
    }

  }

  log(text:any) {
    
  }

}
